//Componentes generales
import React, { useState, useContext, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Routes_gral from "../../utils/Routes_gral";
import "react-phone-input-2/lib/style.css";

// Alertas
import Swal from "sweetalert2";

//Imagenes
import logoG4 from "../../images/LOGO-BLANCO.png";

//Estilos
import "./NewPassword.css";

//Contexto
import authContext from "../../context/authentication/authContex";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

//Iconos
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

function NewPassword(props) {
  const navigate = useNavigate();
  const params = useParams();

  const location = useLocation();
  const { user } = location.state || {};

  //Context de Autenticacion
  const aContext = useContext(authContext);
  const { cambiarContraseña, validarTokenParaCambiarContraseña } = aContext;

  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showRepeatPassword, setShowRepeatPassword] = useState(false);
  const [cargando, setCargando] = useState(false);
  const [haveError, setHaveError] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if(user){
      console.log("Redireccionado desde Debe Cambiar Password");
    }else{
      console.log("Redireccionado desde Mail de Olvide Password");
      if (!params.token) {
        setHaveError(true);
        setError("Token inválido.");
        return;
      }
      setCargando(true);
      const fn = async () => {
        try {
          const resp = await validarTokenParaCambiarContraseña(
            params.token.toString()
          );
          setHaveError(false);
          setError("");
          if (!resp) {
            throw Error;
          }
          setCargando(false);
        } catch (error) {
          console.error("Error al validar token:", error);
  
          const mensajeError = String(
            error?.response?.data?.errMsg ||
              error?.response?.data?.message ||
              error?.response?.data?.msg ||
              error?.message ||
              "Error desconocido."
          );
  
          setCargando(false);
          const mensajeFinal = "ERROR AL VALIDAR TOKEN: " + mensajeError;
          setHaveError(true);
          setError(mensajeFinal);
        }
      };
      fn();
    } 
  }, []);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleRepeatPasswordVisibility = () => {
    setShowRepeatPassword(!showRepeatPassword);
  };

  const alerta = (mensaje, typeIcon) => {
    return Swal.fire({
      text: mensaje,
      icon: typeIcon,
      confirmButtonText: "OK",
    });
  };

  const onSubmit = async () => {
    try {
      if (password.trim() == "" || repeatPassword.trim() == "") {
        alerta(
          "Debe completar todos los campos que son obligatorios",
          "warning"
        );
        return;
      }

      if (password !== repeatPassword) {
        alerta("Las contraseñas deben coincidir.", "warning");
        return;
      }

      if (!/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).{8,}$/.test(password)){
        alerta(
          "La contraseña debe tener al menos 8 caracteres, incluyendo una letra mayúscula, una minúscula y un número.",
          "warning"
        );
        return;
      }

      setCargando(true);
      
      let token = params.token.toString() == ':token' ? user.token : params.token.toString();

      if(token == '') token = user._id;
      
      const resp = await cambiarContraseña(token, password);

      if (!resp) {
        setCargando(false);
        throw Error;
      }

      setCargando(false);
      aContext.limpiarError();
      await alerta("Contraseña cambiada exitosamente!", "success").then(() => {
        setPassword("");
        setRepeatPassword("");
        setTimeout(() => {
          navigate(Routes_gral.login);
        }, 200);
      });
    } catch (error) {
      setCargando(false);
      console.log("Error en cambiar contraseña:", error);

      const mensajeError = String(
        error?.response?.data?.message ||
          error?.response?.data?.msg ||
          error?.message ||
          "Error desconocido."
      );

      setCargando(false);
      const mensajeFinal = "ERROR EN CAMBIAR CONTRASEÑA: " + mensajeError;
      alerta(mensajeFinal, "warning");
    }
  };

  const onLogin = async () => {
    setHaveError(false);
    setError("");
    aContext.limpiarError();
    navigate(Routes_gral.login, { replace: true });
  };

  const handlerPassword = (e) => setPassword(e.target.value);

  const handlerRepeatPassword = (e) => setRepeatPassword(e.target.value);

  return (
    <div className="container-registro">
      {haveError ? (
        <>
          <div className="card-registro">
            <div style={{ textAlign: "center" }}>
              <header>
                <h4 style={{ color: "black", marginTop: "10px" }}>{error}</h4>
              </header>
            </div>
            <button className="btnGoBackStyle" onClick={onLogin}>
              Volver
            </button>
          </div>
        </>
      ) : (
        <>
          <div className="card-registro">
            <div className="containerRegistroTitulo">
              <h2>Recuperar contraseña</h2>
            </div>
            <div style={{ textAlign: "center" }}>
              <p>Ingrese su nueva contraseña:</p>
            </div>
            <div
              className="containerRegistroInput obligatorio"
              style={{ position: "relative" }}
            >
              <input
                className="textRegistroInput"
                id="password"
                placeholder="Nueva contraseña"
                type={showPassword ? "text" : "password"}
                name="password"
                value={password}
                onChange={(e) => handlerPassword(e)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    onSubmit();
                  }
                }}
              />
              <div className="eye" onClick={togglePasswordVisibility}>
                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
              </div>
              <span className="asterisco">*</span>
            </div>
            <div
              className="containerRegistroInput obligatorio"
              style={{ position: "relative" }}
            >
              <input
                className="textRegistroInput"
                id="repeatPassword"
                placeholder="Confirmar contraseña"
                type={showRepeatPassword ? "text" : "password"}
                name="repeatPassword"
                value={repeatPassword}
                onChange={(e) => handlerRepeatPassword(e)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    onSubmit();
                  }
                }}
              />
              <div className="eye" onClick={toggleRepeatPasswordVisibility}>
                <FontAwesomeIcon
                  icon={showRepeatPassword ? faEyeSlash : faEye}
                />
              </div>
              <span className="asterisco">*</span>
            </div>
            {cargando ? (
              <>
                <div>
                  <header>
                    <h4 style={{ color: "black", marginTop: "10px" }}>...</h4>
                  </header>
                </div>
              </>
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                <button className="btnGoBackStyle" onClick={onLogin}>
                  Volver
                </button>
                <button className="btnSubmitStyle" onClick={onSubmit}>
                  Aceptar
                </button>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default NewPassword;